<template>
  <div class="homeGrab">
    <div class="w-1180px mx-auto c3 tracking-1px pt-58px fs16 relative">
      <div>
        <div class="text-center pb-40px">
          <p class="fs32 font-600">客户推送订阅-产品介绍</p>
          <p class="fs22 c9">Product Introduction</p>
        </div>
        <div class="flex justify-center items-center">
          <div class="pr-76px">
            <p class="font-500 fs26">客户推送订阅</p>
            <p class="lh32">
              根据提单信息、船名、航次信息，实时跟踪船期进度。
            </p>
            <el-button
              class="btn mt-24px fs20 lh10"
              type="primary"
              @click="openQQ"
              >立即体验</el-button
            >
          </div>
          <img
            width="522"
            :src="`${ossUrl}/common/market_v2/home/track-1.png`"
          />
        </div>
      </div>

      <div class="pt-80px">
        <div class="text-center pb-80px">
          <p class="fs32 font-600">产品优势</p>
          <p class="fs22 c9">Product Advantage</p>
        </div>
        <div
          v-for="(v, i) in advantage"
          :key="i"
          class="flex justify-center items-center"
          :class="{
            'flex-row-reverse': v.first === 'img',
            'mb-80px': i !== 2,
          }"
        >
          <div class="text-center">
            <p class="fs24 font-500 c3" v-html="v.txt"></p>
          </div>
          <img
            :class="{ 'transform -translate-x-100px': i === 2 }"
            :width="v.imgWidth"
            :src="v.img"
          />
        </div>
      </div>

      <OperationFlow
        title-z-h="订阅流程"
        title-e-n="Transmission Process"
        :flow="flow"
      ></OperationFlow>
    </div>
  </div>
</template>

<script>
import { openQQ } from '@/utils/common.js'
import { ossUrl } from '@/utils/config.js'
import OperationFlow from '@/components/OperationFlow'
/**
 * 货物跟踪落地页
 */
export default {
  name: 'GoodsTrackIntroduce',
  components: { OperationFlow },
  data() {
    return {
      ossUrl,
      advantage: [
        {
          first: 'img',
          txt: '全场景覆盖<br/>舱单跟踪、集装批量订阅',
          imgWidth: '804',
          img: `${ossUrl}/common/market_v2/home/track-2.png`,
        },
        {
          first: 'txt',
          txt: '关注公众号 实现微信推送',
          imgWidth: '805',
          img: `${ossUrl}/common/market_v2/home/track-3.png`,
        },
        // {
        //   first: 'img',
        //   txt: '位置变动更新<br/>微信公众号消息自动提醒<br/>船舶定位信息一目了然',
        //   imgWidth: '570',
        //   img: `${ossUrl}/common/market_v2/home/track-4.png`,
        // },
      ],
      flow: [
        {
          title: '查询',
        },
        {
          title: '订阅',
        },
        {
          title: '消息接收',
        },
      ],
    }
  },
  head() {
    return {
      title: '货物跟踪 - e航无忧',
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: '海运跟踪,货物跟踪,e航无忧',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            'e航无忧为国际物流行业数字化转型提供了货代操作,货代系统,海运查询,船期查询,货物跟踪,数据发送,舱单发送等一站式智能化产品及解决方案。',
        },
      ],
    }
  },
  methods: {
    openQQ,
  },
}
</script>

<style lang="scss" scoped>
.homeGrab {
  position: relative;
  background-image: url(https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/rpa_2.0_home/banner-case.png);
  background-position: center calc(100% + 410px);
  background-repeat: no-repeat;
  .bgTop {
    background-image: url(https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home/banner-case-1.png);
    background-position: center top;
    background-repeat: no-repeat;
    background-size: 1920px 680px;
  }
  .btn {
    width: 140px;
    height: 42px;
    background-color: #0f71ef;
    border-color: #0f71ef;
    border-radius: 4px;
  }
  .block {
    position: relative;
  }
}
</style>
